import type { IntlShape } from 'react-intl';
import trailConditions from '../UpsellFeatureList/trailConditions';
import unlimitedMapDownloads from '../UpsellFeatureList/unlimitedMapDownloads';
import wrongTurnAlerts from '../UpsellFeatureList/wrongTurnAlerts';

const plusFeatures = (intl: IntlShape) => [unlimitedMapDownloads(intl), trailConditions(intl), wrongTurnAlerts(intl)];

export default plusFeatures;
